<template>
<!-- Modal Tarifs -->
<b-modal  ok-only centered size="lg" class="modal fade modal-fullscreen-lg-down" id="ModalTarifs" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen-lg-down modal-lg">
    
      	<div class="tarifs">	
	  		<p>
		  		Séance à l'unité
		  		<h1><span class="prix">50€</span></h1>
		  		<hr />
	  		</p>
	  		<p>
		  		Forfait 5 séances
		  		<h1><span class="prix">225€</span></h1>
	  		</p>
	  		<p>
		  		Forfait 8 séances
		  		<h1 style="margin-top: 20px;"><span class="prix">340€</span></h1>
		  		<hr />
	  		</p>
	  		<p>
		  		Tarif réduit
		  		<h1><span class="prix">40€<sup>*</sup></span></h1>
		  		<span style="font-family: 'brandon_textregular_italic';letter-spacing: 0px;"></span>
	  		</p>
	  	
	  		<p style="font-size:12px; letter-spacing: 0px;font-variant-caps: normal;">
		  		(*) Tarif réduit applicable aux étudiants, demandeurs d'emploi et bénéficiaires du RSA <br>
		  		Paiements par chèque ou espèces. Possibilité de régler en plusieurs fois dans le cadre d'un forfait. <br>
		  		<span style="font-weight:bold;">Certaines mutuelles remboursent partiellement ou totalement les séances.</span>
	  		</p>
	  	</div>
    
  </div>
  
</b-modal>
<!-- /.Modal Tarifs -->
</template>

<script>
export default {}
</script>

<style scoped>



</style>
